import React from 'react';
import { useParams } from 'react-router-dom';
import LibModal from '../../../features/LibModal/LibModal';
import NotFound from '../../../features/NotFound/NotFoundPage';
import PageTitle from '../../../utils/PageTitle';
import { GetSearchParams } from '../../../utils/URL';
import AddressCont from '../Address/AddressCont';
import CustomersProvider from '../CustomerProvider';
import CustomerDetailsStatus from './Components/CustomerDetailsStatus';
import CustomerInfo from './Components/CustomerInfo';
import CustomerTableTab from './Components/CustomerTableTab';
import UserInvoicesPage from './Components/TabTablePages/Invoices/UserInvoicesPage';
import UserPaymentsPage from './Components/TabTablePages/Payments/UserPaymentsPage';
import UserServicesPage from './Components/TabTablePages/Services/UserServicesPage';
import UserSubscriptionsPage from './Components/TabTablePages/Subscriptions/UserSubscriptionsPage';
import UserSupportTicketsPage from './Components/TabTablePages/SupportTickets/UserSupportTicketsPage';
import CustomerDetailsProvider, { useCustomerDetails } from './CustomerDetailsProvider';
import AddNewServiceModal from './Modals/AddNewServiceModal';
import AddNewSubscriptions from './Modals/AddNewSubscriptions';

function TabComponentRender({ data }) {
    const tabName = GetSearchParams('tab') || 'subscriptions';
    switch (tabName) {
        case 'subscriptions':
            return <UserSubscriptionsPage data={data} />;
        case 'invoices':
            return <UserInvoicesPage data={data} />;
        case 'payments':
            return <UserPaymentsPage data={data} />;
        case 'support-ticket':
            return <UserSupportTicketsPage data={data} />;
        case 'services':
            return <UserServicesPage data={data} />;
        default:
            return null;
    }
}

function PageCont() {
    const {
        customerDetailsData,
        setReloadKey,
        handleReload,
        openAppInfoModal,
        setOpenAppInfoModal,
        openModal,
        closeModal,
        modalType
    } = useCustomerDetails();

    PageTitle(
        `${
            customerDetailsData.organization
                ? customerDetailsData.organization
                : customerDetailsData.fullName
        } `
    );

    if (customerDetailsData && Object.keys(customerDetailsData).length === 0) {
        return (
            <div className="inner_page_cont">
                <NotFound
                    title="No Customer Found!"
                    btnTitle="Back to list"
                    path="/customers"
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div className="customers_details_page inner_page_cont">
            {/* <CustomersDetailsHeader /> */}
            <CustomerInfo data={customerDetailsData} handleReload={handleReload} />
            <CustomerDetailsStatus data={customerDetailsData} />
            {/* Address Modal */}
            <AddressCont addressData={customerDetailsData?.addresses} />

            <div className="customers_details_body pb-40">
                <CustomerTableTab data={customerDetailsData} openModal={openModal} />
                <TabComponentRender data={customerDetailsData} />
            </div>
            {openAppInfoModal && (
                <LibModal title="App Features" setOpen={setOpenAppInfoModal}>
                    modal body
                </LibModal>
            )}

            {modalType === 'new-subscription' && (
                <LibModal title="Order New Subscription" setOpen={closeModal}>
                    <AddNewSubscriptions
                        data={customerDetailsData}
                        closeModal={closeModal}
                        setReloadKey={setReloadKey}
                    />
                </LibModal>
            )}
            {modalType === 'new-service' && (
                <LibModal title="Order New Service" setOpen={closeModal}>
                    <AddNewServiceModal
                        data={customerDetailsData}
                        closeModal={closeModal}
                        setReloadKey={setReloadKey}
                    />
                </LibModal>
            )}
        </div>
    );
}

function CustomersDetailsPage() {
    const { userID } = useParams();

    return (
        <CustomersProvider>
            <CustomerDetailsProvider customerId={userID}>
                <PageCont />
            </CustomerDetailsProvider>
        </CustomersProvider>
    );
}

export default CustomersDetailsPage;
